<template>
    <div style="display:flex;height: 100%;flex-direction: column;">
        <div style="height:3rem">
            <van-nav-bar
            title="物流详情"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
            color="linear-gradient(to right, #ff9900, #ff3333)"
            />
        </div>
        <div style="padding:0.5rem 1rem;background:#FAFAFA;flex:1;display:flex;flex-direction: column;">
            <van-panel class="storeName boxshadow" style="margin-bottom:1rem" >
                <div slot="header">
                    <div style="padding:0 1rem">
                        <div class="van-hairline--bottom"  style="display:flex;align-items: center;padding:0.5rem 0;">
                            <img src="../assets/imgs/shopcart_shopicon_icon@2x.png" width="20px;" height="18px;" alt="" style="margin-right:0.5rem;">
                            <span style="font-size:0.875rem;font-weight:bold;">{{ shoplist.goods[0].factoryName }}</span>
                        </div>
                    </div>
                </div>
                <div class="orderMsgBox" style="padding:0">
                    <div>
                        <div style="background:#fff;padding:5px 10px 0">
                            <div style="padding:5px;background:#FAFAFA">
                                <van-row style="border:1px solid #FFFFFF;height:5.5rem;display: flex;">
                                    <van-col span="1" style="text-align:center;line-height:6.25rem;">
                                        <!-- <van-icon name="arrow-left" /> -->
                                    </van-col>
                                    <van-col span="22">
                                        <van-row style="margin-left:0.5rem;">
                                            <van-col span="7">
                                                <img style="width:5.5rem;height:5.5rem;" :src="shoplist.goods[0].goodsUrl" alt="">
                                            </van-col>
                                            <van-col span="16" style="margin-left:0.5rem">
                                                <p style="font-size:1rem;padding:0.5rem 0;font-weight:bold">物流状态：<span style="color:#FF3333">待收货</span></p>
                                                <p class="smallgray">物流公司：<span>{{ shoplist.takeOver.logistics }}</span></p>
                                                <p class="smallgray">运单编号：<span>{{ shoplist.takeOver.logisticsSheet }}</span></p>
                                                <!-- <span class="smallgray">官方电话：<span>95240</span></p> -->
                                            </van-col>
                                        </van-row>
                                    </van-col>
                                    <van-col span="1" style="text-align:center;line-height:6.25rem;">
                                        <!-- <van-icon name="arrow" /> -->
                                    </van-col>
                                </van-row>
                            </div>
                        </div>
                    </div>
                </div>
            </van-panel>
            <div style="flex:1;background:white" class="boxshadow" >
              <van-steps direction="vertical" active-color="#333" :active="0" style="margin-top:1rem;" v-if="courierMsgall.length != 0">
                <van-step class="shipping" v-if="courierMsgall && courierMsgall.length >= 0">
                    <p class="shippingaddress">{{ courierMsgend.AcceptStation }}</p>
                    <p class="shippingtime">{{ courierMsgend.AcceptTime }}</p>
                </van-step>
                <van-step v-for="item in courierMsg" :key="item.AcceptStation" v-if="courierMsgall && courierMsgall.length > 0">
                    <p>{{ item.AcceptStation }}</p>
                    <p>{{ item.AcceptTime }}</p>
                </van-step>
              </van-steps>
              <div>
                  <p style="padding:10px;text-align:center;font-size:1rem;font-weight: 700;">{{ nologisticsMsg }}</p>
              </div>
            </div>
        </div>

    </div>
</template>

<script>
import {  NavBar, Row, Col,Icon,Panel,Button ,Popup ,Stepper ,Swipe, SwipeItem , Step, Steps } from "vant";

export default {
    components: {
        [NavBar.name]: NavBar,
        [Row.name]: Row,
        [Col.name]: Col,
        [Icon.name]: Icon,
        [Panel.name]: Panel,
        [Button.name]: Button,
        [Popup.name]: Popup,
        [Stepper.name]: Stepper,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Step.name]: Step,
        [Steps.name]: Steps,
    },
    data(){
        return{
            shoplist:{},
            courierMsg:[],
            courierMsgall:[],
            courierMsgend:{},
            nologisticsMsg:'',
        }
    },
    methods:{
        onClickLeft(){
            this.$router.go(-1);//返回上一层
        },
        getCourier(logisticsNo,logisticsCode){
            let paramsa = {
            session: this.local.get("session"),
            // logisticsNo: logisticsNo,
            // logisticsCode:logisticsCode
            logisticsNo: 'YT4444850355900',
            logisticsCode:'YTO'
        }
        this.request
            .get("/v1/user/order/logistics", paramsa)
            .then(res => {
                if(JSON.parse(res.data.logistics).Traces.length != 0){
                    // console.log(res.data.logistics)
                    this.courierMsg = JSON.parse(res.data.logistics).Traces 
                    this.courierMsgall = JSON.parse(res.data.logistics).Traces 
                    this.courierMsgend = this.courierMsg[this.courierMsg.length - 1]
                    this.courierMsg = this.courierMsg.slice(0, this.courierMsg.length - 1 ).reverse(); 
                    // console.log(this.courierMsg)
                }else{
                    this.nologisticsMsg = JSON.parse(res.data.logistics).Reason 
                }
            })
            .catch(err => {
            console.log(err);
            });
        },
        //获取订单信息
        getOrderMsg(){
            let params = {
            session:this.local.get('session'),
            orderId:this.$route.query.totalOrderId
            }
            this.request.get("/v1/user/order/get/order",params)
            .then(res => {
                console.log(res)
                this.shoplist = res.data
                this.getCourier(res.data.takeOver.logisticsSheet,res.data.takeOver.logisticsCode)
            })
            .catch(err => {
                console.log(err);
            });
        },
    },
    created(){
        console.log(this.$route.query.totalOrderId)
        this.getOrderMsg()
        // this.getCourier()
    }
}
</script>

<style lang="less" scoped>
.van-nav-bar {
    background: linear-gradient(to right, #ff9900, #ff3333);
    position: relative;
    .van-icon,
    .van-nav-bar__text,
    .van-nav-bar__title {
      color: #fff;
    }
    .van-nav-bar__left{
        top: 0;
        font-size: 0.875rem;
    }
    .van-nav-bar__title{
        font-weight: bold;
        font-size: 1.25rem;
    }
}
.storeName{
    height: 10rem;
}
/deep/ .van-step__line{
    display: none;
}
/deep/ .van-step{
    font-size:0.8rem;
}
/deep/ .van-step__circle-container{
    font-size: 1.4rem;
    /deep/ .van-icon{
        color: #0099FF!important;
    }
}
/deep/ .van-step__title{
    margin-left: 0.5rem;
}
.shippingaddress{
    font-size:0.875rem;font-weight:700;
}
</style>